module.exports = __webpack_public_path__ + "img/star-with-paddings.eff66a16.svg";